<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { TagTypes } from './TagProp';
  import { TagSize } from '$shared/constants/TagSize';

  interface Props {
    disabled?: boolean;
    ariaLabel?: string;
    icon?: string;
    type?: TagTypes;
    size?: TagSize;
    name?: string;
    title?: string;
    children?: import('svelte').Snippet;
    onclick?: (e: MouseEvent) => void;
  }

  let {
    disabled = false,
    ariaLabel = undefined,
    icon = '',
    type = TagTypes.None,
    size = TagSize.Default,
    name = '',
    title = '',
    children,
    onclick
  }: Props = $props();

  let iconColor = $derived(
    (() => {
      switch (type) {
        case TagTypes.Active:
        case TagTypes.DarkGreyed:
          return 'white';
        case TagTypes.Warn:
        case TagTypes.Orange:
          return '';
        default:
          return 'grey';
      }
    })()
  );
</script>

<button
  data-cy={name}
  type="button"
  class="comp-tag {type} {size}"
  {disabled}
  aria-label={ariaLabel}
  {onclick}
>
  {#if icon}
    <div class="icon">
      <Icon value="{icon} {iconColor}" />
    </div>
  {/if}
  <div class="label" {title}>{@render children?.()}</div>
</button>

<style src="./Tag.css">
</style>
